import { useGraphqlDelete } from "@mzara/component";

export const useAppointmentBoardInvitationDeleteMutation = () => {
    return useGraphqlDelete('appointmentInvitation');
};
